import apiClient from './apiClient';
import type { WorkOrderTabRow } from '../types/workOrdersTab';

export interface GetAllWorkOrdersParams {
  page?: number;
  pageSize?: number;
  status?: string;
  projectKey?: string;
  clientKey?: string;
  labLocation?: string;
  search?: string;
  startDateFrom?: string;
  startDateTo?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

interface PaginatedResponse {
  data: WorkOrderTabRow[];
  total: number;
  page: number;
  pageSize: number;
}

export const getAllWorkOrders = async (
  params: GetAllWorkOrdersParams = {},
): Promise<PaginatedResponse> => {
  const response = await apiClient.get<PaginatedResponse>('/workorders/all', { params });
  return response.data;
};

export const getWorkOrderStatusCounts = async (): Promise<Record<string, number>> => {
  const response = await apiClient.get<Record<string, number>>('/workorders/status-counts');
  return response.data;
};

export const createStandaloneWorkOrder = async (data: {
  projectKey: string;
  workOrderName?: string;
  workOrderStartDate?: string;
  remarks?: string;
}): Promise<{ WorkOrderKey: string; WorkOrderId: string; ProjectId: string }> => {
  const response = await apiClient.post('/workorders/standalone', data);
  return response.data;
};
